import styled from 'styled-components';

export const Dot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.hotelsList.mapPinBackground};
`;
